import { render, staticRenderFns } from "./PojistovnaSelect.vue?vue&type=template&id=8be3214e&"
import script from "./PojistovnaSelect.vue?vue&type=script&lang=ts&"
export * from "./PojistovnaSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports